import { render, staticRenderFns } from "./statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items.vue?vue&type=template&id=88d0f688&scoped=true&"
import script from "./statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items.scss?vue&type=style&index=0&id=88d0f688&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d0f688",
  null
  
)

export default component.exports